<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay } from "swiper/modules";

// CSS ضروري
import "swiper/css";
import "swiper/css/pagination";
</script>

<template>
  <div class="col-xl-4" v-if="categories.length">
    <div class="card card-xl-stretch mb-5 mb-xl-8">
      <!-- Header -->
      <div class="card-header align-items-center border-0 mt-3">
        <h3 class="card-title align-items-start flex-column">
          <span class="fw-bold text-dark fs-3">
            <i
              class="fa fa-list"
              style="
                border-radius: 10px;
                padding: 8px 10px;
                background: #f4dc1763;
                color: #ff9d00;
              "
            ></i>
            أداء بنك الأسئلة
          </span>
          <span class="text-gray-400 mt-2 fw-semibold fs-6">
            تصفح أدائك في بنك الأسئلة
          </span>
        </h3>
      </div>

      <!-- Body -->
      <div class="card-body pt-5">
        <div v-if="isLoadingQbanks" class="text-center mt-3">
          <span class="spinner-border spinner-border-lg text-success"></span>
          <p>جاري تحميل الأداء...</p>
        </div>

        <div v-else>
          <Swiper
            :modules="[Pagination, Autoplay]"
            :slides-per-view="1"
            :space-between="10"
            :pagination="{ clickable: true }"
            :autoplay="{ delay: 2500, disableOnInteraction: false }"
            loop
            class="mySwiper"
          >
            <SwiperSlide v-for="(cat, index) in categories" :key="index">
              <div class="d-flex mb-7">
                <div class="d-flex flex-column flex-grow-1 pe-3">
                  <a
                    href="javascript:void(0)"
                    class="fs-5 text-gray-800 text-hover-primary fw-bold"
                  >
                    {{ cat.name }}
                  </a>
                  <span class="text-gray-400 fw-semibold fs-7">
                    مجموع النقاط
                    <a href="javascript:void(0)" class="text-success fw-bold">
                      {{ cat.points }}
                    </a>
                  </span>
                  <span class="text-gray-400 fw-semibold fs-7">
                    الترتيب
                    <a href="javascript:void(0)" class="text-success fw-bold">
                      #{{ cat.user_rank }}
                    </a>
                  </span>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl } from "@/utils/api";

export default {
  name: "DashboardView",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      isLoadingQbanks: false,
      categories: [], // هنا نخزن sub_category + child_categories
    };
  },
  mounted() {
    this.getQbankLatest();
  },
  methods: {
    async getQbankLatest() {
      this.isLoadingQbanks = true;
      try {
        const response = await fetch(`${apiUrl}/qbanks/latest`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          // توحيد sub_category + child_categories
          let merged = [];
          if (data.sub_category) merged.push(data.sub_category);
          if (data.child_categories && data.child_categories.length) {
            merged = merged.concat(data.child_categories);
          }

          this.categories = merged;
        } else {
          console.error("فشل في جلب بيانات بنك الأسئلة");
        }
      } catch (error) {
        console.error("خطأ في جلب بيانات بنك الأسئلة:", error);
      } finally {
        this.isLoadingQbanks = false;
      }
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 10px;
}

.card-body {
  text-align: right;
}
</style>
